import { createContext, Dispatch, useContext, useState } from 'react';

import { ClientType } from '__generated__/GQL';
import { FCWithChildren } from 'common/types';

import { ContactOptions } from '../../components/ContactPicker';
import { Client } from '../../pages/Clients/hooks/useGetClient';

type ContextType = [
  ContactOptions,
  Dispatch<React.SetStateAction<ContactOptions>>,
];

const ClientContactContext = createContext<ContextType>([
  {
    clientContactIds: [],
    isUserCcedOnEmails: false,
  },
  () => {},
]);

interface ClientContactsProviderProps {
  client: Client;
  clientContactIds: string[];
}

export const ClientContactsProvider: FCWithChildren<
  ClientContactsProviderProps
> = ({ children, client, ...props }) => {
  const clientContactIds =
    client.type === ClientType.PrivateIndividual && client.contacts?.[0]
      ? [client.contacts[0].clientContactId]
      : props.clientContactIds;

  const [contactOptions, setContactOptions] = useState<ContactOptions>({
    clientContactIds,
    isUserCcedOnEmails: false,
  });

  return (
    <ClientContactContext.Provider value={[contactOptions, setContactOptions]}>
      {children}
    </ClientContactContext.Provider>
  );
};

export const useClientContacts = () => {
  const context = useContext(ClientContactContext);

  if (!context) {
    throw new Error(
      'useClientContacts can only be used inside of a ClientContactsProvider',
    );
  }

  return context;
};
